/*
 * @Author: 刘小博
 * @Date: 2023-02-03 14:58:56
 * @LastEditTime: 2023-04-14 17:01:16
 * @LastEditors: 肖玲
 * @Description:
 * 基础信息
 */
const basicInformationRouter = [
  // 连锁架构
  {
    path: '/masterDataSystem/chain-architecture',
    name: 'chainArchitecture',
    component: () =>
      import(
        /*webpackChunkName:"brand" */
        '@/views/master-data/master-data-maintain/basic-information/chain-architecture/Page.vue'
      ),
    meta: {
      SecondaryMenu: '基础信息', //二级菜单
      title: '连锁架构',
    },
  },
  // 连锁架构  批量导入
  {
    path: '/masterDataSystem/chainArchitecture-batchimport',
    name: 'chainArchitectureBatchimport',
    component: () =>
      import(
        /*webpackChunkName:"brand" */
        '@/views/master-data/master-data-maintain/basic-information/chain-architecture/BatchImport.vue'
      ),
    meta: {
      SecondaryMenu: '基础信息', //二级菜单
      title: '批量导入连锁架构',
      breadcrumb: [
        {
          title: '连锁架构',
          name: 'chainArchitecture',
        },
      ],
    },
  },
  // 连锁架构  详情
  {
    path: '/masterDataSystem/chainArchitecture-detail/:client_id',
    name: 'chainArchitectureDetail',
    component: () =>
      import(
        /*webpackChunkName:"brand" */
        '@/views/master-data/master-data-maintain/basic-information/chain-architecture/Detail.vue'
      ),
    meta: {
      SecondaryMenu: '基础信息', //二级菜单
      title: '连锁架构详情',
      breadcrumb: [
        {
          title: '连锁架构',
          name: 'chainArchitecture',
        },
      ],
    },
  },
  // 连锁品牌
  {
    path: '/masterDataSystem/brand-manage',
    name: 'brandManage',
    component: () =>
      import(
        /*webpackChunkName:"brand" */
        // '@/views/masterDataSystem/brand/Manage.vue' // 待删除
        '@/views/master-data/master-data-maintain/basic-information/chain-brand/Page.vue'
      ),
    meta: {
      SecondaryMenu: '基础信息', //二级菜单
      title: '连锁品牌',
    },
  },
  // 导入品牌
  {
    path: '/masterDataSystem/brand-import',
    name: 'brandImport',
    component: () =>
      import(
        /*webpackChunkName:"brand" */
        // '@/views/masterDataSystem/brand/ClientImport.vue' // 待删除
        '@/views/master-data/master-data-maintain/basic-information/chain-brand/Import.vue'
      ),
    meta: {
      SecondaryMenu: '基础信息', //二级菜单
      title: '导入品牌',
      breadcrumb: [
        {
          title: '连锁品牌',
          name: 'brandManage',
        },
      ],
    },
  },
  // 科室管理
  {
    path: '/masterDataSystem/hospital-departments',
    name: 'hospitalDepartmentsList',
    component: () =>
      import(
        /*webpackChunkName:"hospitalDepartment" */
        // '@/views/masterDataSystem/hospital-departments/List.vue' // 待删除
        '@/views/master-data/master-data-maintain/basic-information/hospital-dept-manage/Page.vue'
      ),
    meta: {
      SecondaryMenu: '基础信息', //二级菜单
      title: '科室管理',
    },
  },
  // 科室分类
  {
    path: '/masterDataSystem/hospital-departments/category',
    name: 'hospitalDepartmentsCategory',
    component: () =>
      import(
        /*webpackChunkName:"hospitalDepartment" */
        // '@/views/masterDataSystem/hospital-departments/Category.vue'  // 待删除
        '@/views/master-data/master-data-maintain/basic-information/hospital-dept-manage/Category.vue'
      ),
    meta: {
      SecondaryMenu: '基础信息', //二级菜单
      title: '科室分类',
      breadcrumb: [
        {
          title: '科室管理',
          name: 'hospitalDepartmentsList',
        },
      ],
    },
  },

  // 科室导入
  {
    path: '/masterDataSystem/hospital-departments/import',
    name: 'hospitalDepartmentsImport',
    component: () =>
      import(
        /*webpackChunkName:"hospitalDepartment" */
        // '@/views/masterDataSystem/hospital-departments/ClientImport.vue' // 待删除
        '@/views/master-data/master-data-maintain/basic-information/hospital-dept-manage/Import.vue'
      ),
    meta: {
      SecondaryMenu: '基础信息', //二级菜单
      title: '导入科室',
      breadcrumb: [
        {
          title: '科室管理',
          name: 'hospitalDepartmentsList',
        },
      ],
    },
  },
]

export default basicInformationRouter
